export default "__VITE_ASSET__C4UQJ3Me__"